module.exports = __webpack_public_path__ + "startpage-746fed5a/A2-77853c25da81c06d1a26546630472a5a.svg";